import React from 'react';
import { useHits } from 'react-instantsearch';
import Img, { CloudimageProvider } from 'react-cloudimage-responsive';
import { cloudImageConfig } from '../../../cloudimage';
import { ChevronIconRight } from '../../common/Icons';

export default function ModelHits({ modelOverviewUrl, modelOverviewTitle }) {
    const { hits } = useHits();

    if (hits.length === 0) return null;

    return (
        <div className="col-12">
            <p className="font-weight-bold mb-6">{window.Translator.trans('app.header.search.results.models')}</p>
            <div className="row gutters-2">
                {hits.slice(0, 5).map((model, index) => (
                    <div key={index} className="col-12">
                        <div className="d-flex align-items-center gap-4">
                            <div className="search-model-image-wrapper">
                                <CloudimageProvider config={cloudImageConfig}>
                                    <Img
                                        className="flex-shrink-0"
                                        src={model?.image || model?.image_url || ''}
                                        alt={`${model?.brand} ${model?.model}`}
                                    />
                                </CloudimageProvider>
                            </div>
                            <a
                                className="stretched-link text-decoration-none text--14 mb-0 font-weight-semi-bold"
                                href={model?.url}
                                title={model?.brand}
                                target="_self"
                            >
                                <p className="">
                                    {model?.brand}{' '}
                                    <span className="text-muted--40">{model?.model}</span>
                                </p>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
            {modelOverviewUrl && (
                <div className="d-flex align-items-center gap-1">
                    <a className="btn p-0 text--14" href={modelOverviewUrl}>
                        {modelOverviewTitle || window.Translator.trans('app.header.search.results.models_overview')}
                    </a>
                    <ChevronIconRight className="icon" />
                </div>
            )}
        </div>
    );
}
